import React from 'react';
import {
  Box,
  Flex,
  HStack,
  Link,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
  useColorModeValue,
  Container,
  Heading,
  Image
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Logo from './Logo';

const Navigation = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { user, signOut, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const [isUpgraded, setIsUpgraded] = React.useState(false); // This will be replaced with actual subscription check
  const bgColor = useColorModeValue('white', 'gray.900');
  const hoverBg = useColorModeValue('gray.200', 'gray.700');

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  if (!user) return null;

  return (
    <Box bg={bgColor} px={4} position="sticky" top={0} zIndex={1000}>
      <Container maxW="container.xl">
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <IconButton
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={'Open Menu'}
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={'center'}>
            <Link as={RouterLink} to="/" _focus={{ boxShadow: 'none' }} _hover={{ textDecoration: 'none' }}>
              <Logo variant="full" size="md" />
            </Link>
            <Link as={RouterLink} to="/dashboard" color={isActive('/dashboard') ? 'blue.500' : 'gray.600'}>
              Dashboard
            </Link>
            {isAdmin && (
              <Link as={RouterLink} to="/admin" color={isActive('/admin') ? 'blue.500' : 'gray.600'}>
                Admin
              </Link>
            )}
          </HStack>

          <Flex alignItems={'center'}>
            <Menu>
              <MenuButton
                as={Button}
                rounded={'full'}
                variant={'link'}
                cursor={'pointer'}
                minW={0}
              >
                {user.email}
              </MenuButton>
              <MenuList>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </MenuList>
            </Menu>
            {!isUpgraded && (
              <Button
                as={RouterLink}
                to="/pricing"
                colorScheme="blue"
                size="sm"
                ml={4}
              >
                Upgrade
              </Button>
            )}
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default Navigation;
